<svg-icon
  [src]="url"
  [svgStyle]="{ 'height.rem': size, 'width.rem': size}"
></svg-icon>
